module.exports = {
	acl(user, defineAbility) {
		const ability = defineAbility((can, cannot) => {
			if (user.role === 'admin') {
				can('manage', 'Vendor');
			} else {
				cannot('manage', 'Vendor');
			}
		});

		return { ability };
	}
};
